import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  setProductListingType,
  setProductsPerRow,
} from '../../Actions/ProductListing.action';
import useBreakpoint from '../../Hooks/useBreakpoint';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import useIsMobile from '../../Hooks/useIsMobile';
import { ProductListingType } from '../../Reducers/ProductListing.reducer';

const ProductListingResizeObserver = () => {
  const { productListingType } = useTypedSelector(
    (state) => state.productListing
  );

  const dispatch = useDispatch();

  const breakpoint = useBreakpoint();
  const isMedium = useIsMobile('medium');

  const getProductsPerRowForBreakpoint = useCallback(() => {
    switch (breakpoint) {
      case 'sm':
        return 2;
      case 'md':
        return 3;
      case 'lg':
        return 4;
      default:
        return 5;
    }
  }, [breakpoint]);

  useEffect(() => {
    switch (productListingType) {
      case ProductListingType.Grid:
        dispatch(setProductsPerRow(getProductsPerRowForBreakpoint()));
        return;
      case ProductListingType.List:
        dispatch(setProductsPerRow(1));
        return;
      case ProductListingType.SingleCard:
        if (isMedium) {
          dispatch(setProductsPerRow(1));
        } else {
          dispatch(setProductListingType(ProductListingType.List));
        }
        return;
    }
  }, [
    dispatch,
    getProductsPerRowForBreakpoint,
    productListingType,
    breakpoint,
    isMedium,
  ]);

  return null;
};

export default ProductListingResizeObserver;
